import { useState } from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { updateApplicationStatus } from "@/services/jobintelSavedJobsService";
import { toast } from "sonner";

const STATUS_OPTIONS = [
  { value: 'saved', label: 'Saved' },
  { value: 'applied', label: 'Applied' },
  { value: 'interviewing', label: 'Interviewing' },
  { value: 'offer', label: 'Offer' },
  { value: 'rejected', label: 'Rejected' },
  { value: 'withdrawn', label: 'Withdrawn' },
  { value: 'passed', label: 'Passed' },
];

interface ApplicationStatusDropdownProps {
  savedJobId: string;
  currentStatus: string;
}

export function ApplicationStatusDropdown({ savedJobId, currentStatus }: ApplicationStatusDropdownProps) {
  const [status, setStatus] = useState(currentStatus);

  const handleChange = async (newStatus: string) => {
    const prev = status;
    setStatus(newStatus);
    try {
      await updateApplicationStatus(savedJobId, newStatus);
      toast.success(`Status updated to ${STATUS_OPTIONS.find(o => o.value === newStatus)?.label}`);
    } catch {
      setStatus(prev);
      toast.error("Failed to update status");
    }
  };

  return (
    <Select value={status} onValueChange={handleChange}>
      <SelectTrigger className="w-[140px] h-8 text-xs">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {STATUS_OPTIONS.map(opt => (
          <SelectItem key={opt.value} value={opt.value} className="text-xs">
            {opt.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
